import {View, Text} from '@react-pdf/renderer';
import {TFunction} from 'i18next';

import {deepDiveStyles} from '../styles/deepDiveStyles';

import {ScreeningRecommendations} from '../../../../../../types/ApplicantScreeningReport';
import {SupportedLanguages} from '../../../../../../types/SupportedLanguages';

interface Props {
  interviewSuggestions: ScreeningRecommendations;
  lang: SupportedLanguages;
  t: TFunction;
}

export const Suggestions = ({interviewSuggestions, lang, t}: Props) => {
  return (
    <View style={deepDiveStyles.container} wrap={false}>
      <Text style={deepDiveStyles.primaryText}>{interviewSuggestions.pillarTitle[lang]}</Text>
      <View style={{paddingLeft: '8px', marginBottom: '8px'}}>
        {interviewSuggestions.interviewQuestions[lang].map((question) => (
          <Text key={question} style={deepDiveStyles.secondaryText}>
            {question.replace(/\n/g, ' ').charAt(0).toUpperCase() + question.slice(1)}
          </Text>
        ))}
      </View>
      <Text style={deepDiveStyles.primaryText}>
        {t('screeningModule.report.recommendations.recommendationsPage2.whatToLookFor')}
      </Text>
      <View style={{paddingLeft: '8px'}}>
        {interviewSuggestions.whatToLookFor[lang].map((hint, idx) => (
          <Text key={`${hint} ${idx}`} style={deepDiveStyles.secondaryText}>
            {`• ${hint.replace(/\n/g, ' ').charAt(0).toUpperCase() + hint.slice(1)}`}
          </Text>
        ))}
      </View>
    </View>
  );
};
